<template>
  <div class="screenpic">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>邀约与征稿</el-breadcrumb-item>
          <el-breadcrumb-item>图片直播</el-breadcrumb-item>
          <el-breadcrumb-item>筛选图片</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <div @click="goTable"
           class="refresh">
        <img width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div> -->
    </div>

    <div class="main">
      <div class="head">

        <el-tooltip class="item" effect="light" :content="desc || '暂无备注'" placement="right">
          <h4 style="cursor: pointer;">图片直播筛选 · {{title}}</h4>
        </el-tooltip>
        
      </div>

      <screen></screen>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate, formatConversion } from "@/plugins/getdate";
import screen from "./components/screen/index";


import {
  getActivityLive
} from "@/api/activityLive";

export default {
  components: {
    screen
  },
  data () {
    return {
      title:'',
      desc:''
    };
  },
  methods: {
    goTable () {
      this.$router.push("/workflow/listTask");
    },
    

    //设置任务状态
    async getActivityLiveAsync (val) {
      let { status, data, message } = await getActivityLive(
        val
      );
      if(status){
        this.title = data.title
        this.desc = data.desc
      }
    },

  },
  created () {
    this.getActivityLiveAsync(this.$route.query.id)
  },
  beforeDestroy () { },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./livepic.scss";
@import "@/constants/elHeader.scss";
// .descdialogVisible ::v-deep .el-dialog__body {
//   min-height: 200px;
// }
</style>
